interface SkeletonProps {
  className?: string;
  width?: string | number;
  height?: string | number;
  rounded?: "sm" | "md" | "lg" | "full";
}

export function Skeleton({ className = "", width, height = 14, rounded = "md" }: SkeletonProps) {
  const r =
    rounded === "full" ? "rounded-full" : rounded === "lg" ? "rounded-lg" : rounded === "sm" ? "rounded-sm" : "rounded";
  return (
    <div
      className={`bg-text/[.06] animate-pulse ${r} ${className}`}
      style={{ width, height }}
    />
  );
}

export function SkeletonRow({ cols = 5 }: { cols?: number }) {
  return (
    <div className="flex gap-3 py-2">
      {Array.from({ length: cols }).map((_, i) => (
        <Skeleton key={i} className="flex-1" height={14} />
      ))}
    </div>
  );
}
